import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.7986 6.43636L6.49554 0.880809C6.22279 0.595068 5.77721 0.595068 5.50446 0.880809L0.20143 6.43636C-0.0671428 6.71773 -0.0671429 7.17084 0.20143 7.4522C0.474183 7.73794 0.919757 7.73794 1.19251 7.4522L6 2.41578L10.8075 7.4522C11.0802 7.73794 11.5258 7.73794 11.7986 7.4522C12.0671 7.17084 12.0671 6.71773 11.7986 6.43636Z",
  fill: "#B2C0CD"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }